import { sendPost } from '../http.js'
const prefix = '/customer'
const api = {
	'preserveMethodList': {
        url: '/preserve/method'
    },
    'methodCourse': {
        url: '/preserve/method/course'
    },
    'addPreserveMethod': {
        url: '/add/preserve/method'
    },
    'editPreserveMethod': {
        url: '/edit/preserve/method'
    },
    'preserveMethodInfo': {
        url: '/preserve/method/info'
    },
    'removePreserveMethod': {
        url: '/remove/preserve/method'
    },
    'preserveProducts': {
        url: '/preserve/method/products'
    }
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        mutationsName: api[key].mutationsName,
        requestFun:(params) => {
            return sendPost(prefix + api[key].url, params)
        }
    } 
}
export default requestFunObj
